export const pluckWith = f => a =>
    Object.fromEntries(Object.entries(a).filter(f));

export const pluck = (...keys) => pluckWith(([key]) => !keys.includes(key))

const comp = (f, g) => x => g(f(x));
export const pipe = (...fs) => fs.reduce(comp);
export const compose = (...fs) => fs.reduceRight(comp);

export const map = f => a => a.map(f);